import { apiPost } from "../baseApi";

export const refresh = async (data) => {
  try {
    const response = await apiPost("_refreshToken", data);
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
